import {Component, EventEmitter, Input, NgModule, Output} from '@angular/core';

@Component({
  selector: 'sd-button-toggle-group',
  standalone: true,
  template: `<div class="inline-flex overflow-hidden rounded-lg border border-[var(--m365-border-rest,#ececf0)]"><ng-content></ng-content></div>`,
  host: {class: 'sd-toggle-group inline-flex'},
})
export class SdButtonToggleGroup {
  @Input() value: unknown;
  @Input() multiple = false;
  @Input() disabled = false;
  @Output() change = new EventEmitter<{value: unknown}>();
  @Output() valueChange = new EventEmitter<unknown>();

  select(value: unknown): void {
    this.value = value;
    this.valueChange.emit(value);
    this.change.emit({value});
  }
}

@Component({
  selector: 'sd-button-toggle',
  standalone: true,
  template: `
    <button
      type="button"
      class="px-3 py-1.5 text-sm"
      [class.bg-neutral-100]="selected"
      [class.font-semibold]="selected"
      (click)="onClick()"
    >
      <ng-content></ng-content>
    </button>
  `,
})
export class SdButtonToggle {
  @Input() value: unknown;
  @Input() disabled = false;

  constructor(private readonly group: SdButtonToggleGroup) {}

  get selected(): boolean {
    return this.group?.value === this.value;
  }

  onClick(): void {
    this.group?.select(this.value);
  }
}

@NgModule({
  imports: [SdButtonToggleGroup, SdButtonToggle],
  exports: [SdButtonToggleGroup, SdButtonToggle],
})
export class SdButtonToggleModule {}
